import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { OnboardingDialog } from "~/pages/Onboarding/OnboardingDialog";
import { getConfigOption } from "~/store/selectors/selector.configOptions";
import OnboardingLayout from "./OnboardingLayout";

export const SetPasswordPage = () => {
  const navigate = useNavigate();
  const showSetPasswordForm = useSelector((state) => getConfigOption(state, "show_set_password"));
  const shouldShowSecondStep = useSelector((state) => getConfigOption(state, "show_sample_projects_wizard_step"));

  const [step, setStep] = useState(() => {
    if (showSetPasswordForm) {
      return 1;
    }

    if (shouldShowSecondStep) {
      return 2;
    }
  });

  useEffect(() => {
    if (!showSetPasswordForm && !shouldShowSecondStep) {
      navigate("/projects");
    }
  }, [navigate, shouldShowSecondStep, showSetPasswordForm]);

  return (
    <OnboardingLayout>
      <OnboardingDialog
        step={step}
        setStep={setStep}
      />
    </OnboardingLayout>
  );
};

export default SetPasswordPage;
